<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Payroll Process"
            />
        </div>

         <section id="basic-tabs-components">
        <div class="row match-height">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item active">
                    <a class="nav-link active" id="draft-tab-fill" data-bs-toggle="tab" href="#draft-tab" role="tab" aria-controls="draft-tab" aria-selected="false">Draft</a>
                  </li>
                  <li class="nav-item active">
                    <a class="nav-link" id="pending-tab-fill" data-bs-toggle="tab" href="#pending-approval-tab" role="tab" aria-controls="pending-approval-tab" aria-selected="false">Pending Approval</a>
                  </li>
                  <li class="nav-item active">
                    <a class="nav-link" id="approval-tab-fill" data-bs-toggle="tab" href="#approval-tab" role="tab" aria-controls="approval-tab" aria-selected="false">Approved</a>
                  </li>
                  <li class="nav-item active">
                    <a class="nav-link" id="statement-tab-fill" data-bs-toggle="tab" href="#statement-tab" role="tab" aria-controls="statement-tab" aria-selected="false">Statement</a>
                  </li>
                </ul>
                <hr>

                <div class="tab-content">
                  <div class="tab-pane show active" id="draft-tab" role="tabpanel" aria-labelledby="draft-tab-fill">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                        <div class="mb-1">
                          <label for="colFormLabel" class="col-form-label">Payroll Category</label>
                          <v-select
                              placeholder="Select Payroll Category"
                              v-model="payrollCategory"
                              :options="payrollCategoryList"
                              :reduce="name => name.value"
                              label="name"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                        <div class="mb-1">
                          <label for="colFormLabel" class="col-form-label">Calculation Period</label>
                          <v-select
                              placeholder="Select Calculation Period"
                              v-model="calculationPeriod"
                              :options="payHeadCalculationPeriod"
                              :reduce="name => name.value"
                              label="name"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-sm-6 col-md-3 col-lg-2  mb-1">
                        <div class="mb-1">
                          <label for="colFormLabel" class="col-form-label">Start Date</label>
                          <vField
                              v-model="startDate"
                              name="date"
                              id="date"
                              type="date"
                              class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3 col-lg-2  mb-1">
                        <div class="mb-1">
                          <label for="colFormLabel" class="col-form-label">End Date</label>
                          <vField
                              v-model="endDate"
                              name="date"
                              id="date"
                              type="date"
                              class="form-control"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
                        <button
                            style="min-width: 64px;"
                            @click="onClickToGo"
                            class="btn btn-primary btn-block waves-effect waves-float waves-light"
                        > Process
                        </button>
                      </div>
                    </div>
                    <DraftTab @reprocess="payrollReProcessing"/>
                  </div>

                  <div class="tab-pane" id="pending-approval-tab" role="tabpanel" aria-labelledby="pending-approval-tab-fill">
                    <PendingApprovalTab @reprocess="payrollReProcessing"/>
                  </div>

                  <div class="tab-pane" id="approval-tab" role="tabpanel" aria-labelledby="approval-tab-fill">
                    <ApprovalTab />
                  </div>

                  <div class="tab-pane" id="statement-tab" role="tabpanel" aria-labelledby="statement-tab-fill">
                    <StatementTab />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import { computed } from 'vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import DraftTab from '@/components/molecule/company/hrm-payroll/payroll/DraftTab.vue';
import PendingApprovalTab from '@/components/molecule/company/hrm-payroll/payroll/PendingApprovalTab.vue';
import ApprovalTab from '@/components/molecule/company/hrm-payroll/payroll/ApprovalTab.vue';
import StatementTab from '@/components/molecule/company/hrm-payroll/payroll/StatementTab.vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const payHeadCalculationPeriod = ref([]);
const payrollCategoryList = ref([]);
const calculationPeriod = ref('')
const payrollCategory = ref('')
const startDate = ref('')
const endDate = ref('')
const token = computed(() => localStorage.getItem('token'));
const params = ref({
  offset: 20,
});

const {
  fetchTypes,
  createPayrollProcessData
} = handleHrPayroll()

const onClickToGo = () => {
  createPayrollProcess();
}

const getTypes = async () => {
  let query =`?company_id=${route.params.companyId}`;
  await fetchTypes(query).then(res => {
    if (!res.status){
      payHeadCalculationPeriod.value = [];
      return
    }

    const data = res.data || {};
    payHeadCalculationPeriod.value = data.payHeadCalculationPeriod || [];
    payrollCategoryList.value = data.payrollCategory || [];

  }).catch(err => {
    console.log(err)
  })
}

const createPayrollProcess = async () => {
    const query = getQuery();
    loading.value = true

    await createPayrollProcessData(query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }
        showSuccess(res.message)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const payrollReProcessing = async (item) => {
  const confirmed = confirm("Are you sure you want to reprocess?");
  if (!confirmed) return;

  let query = `?company_id=${route.params.companyId}`;
  query += `&payroll_category=${item.payroll_category}`
  query += `&calculation_period=${item.payroll_period}`
  query += `&start_date=${item.payroll_start_date}`
  query += `&end_date=${item.payroll_end_date}`
  query += `&status=reprocess`

  await createPayrollProcessData(query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (payrollCategory.value) query += '&payroll_category=' + payrollCategory.value;
    if (calculationPeriod.value) query += '&calculation_period=' + calculationPeriod.value;
    if (startDate.value) query += '&start_date=' + startDate.value;
    if (endDate.value) query += '&end_date=' + endDate.value;
    return query;
}

onMounted(() => {
  Promise.all([
    getTypes()
  ])
})

</script>

<style scoped>
.head td {
  text-align: right;
}
</style>